<template>
  <div id="register-container" :class="webnamefinal">
    <Navigationbar v-if="!isInIframe && !isApp" :webname="webnamefinal">
    </Navigationbar>
    <b-loading :is-full-page="true" :active="!isDataLoaded"></b-loading>
    <div id="content-frame" v-if="isDataLoaded">
      <div id="content-inner">
        <div id="content-logo" class="top-part-notmobile">
          <img :src="logourl" class="top-logo" />
        </div>
        <div id="content-main">
          <transition name="fade1" v-if="existingUser == false">
            <Step0 v-if="getCurrentStep === 0"> </Step0>
            <Step1 v-if="getCurrentStep === 1"> </Step1>
            <Step2 v-if="getCurrentStep === 2"> </Step2>
            <Step3 v-if="getCurrentStep === 3"> </Step3>
            <Step4 v-if="getCurrentStep === 4"> </Step4>
          </transition>
          <RegisterPreviousUser :loginData="loginData" v-else>
          </RegisterPreviousUser>
        </div>
      </div>
    </div>
    <Footerbar v-if="!isInIframe && isDataLoaded == true && !isApp">
    </Footerbar>
  </div>
</template>
<script>
import Step0 from '@/components/Register/Step0.vue'
import Step1 from '@/components/Register/Step1.vue'
import Step2 from '@/components/Register/Step2.vue'
import Step3 from '@/components/Register/Step3.vue'
import Step4 from '@/components/Register/Step4.vue'
import RegisterPreviousUser from '@/components/Register/RegisterPreviousUser.vue'
import { topLevelPageMixin } from '@/components/mixins/topLevelPageMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'

import Navigationbar from '@/components/UI/Navigationbar.vue'
import Footerbar from '@/components/UI/Footerbar.vue'
export default {
  name: 'RRegister',
  mixins: [topLevelPageMixin, ToolsMixin],
  props: {
    existingUser: {
      type: Boolean,
      default: false
    },
    loginData: {
      type: Object,
      default: null
    },
    webname: {
      type: String,
      default: '' // navandume
    },
    env: {
      type: String,
      default: 'PRO' // navandume
    },
    isapp: {
      type: String,
      default: 'false' // navandume
    }
  },
  components: {
    Step0,
    Step1,
    Step2,
    Step3,
    Step4,
    RegisterPreviousUser,
    Navigationbar,
    Footerbar
  },
  data: () => ({
    //isDataLoaded: false,
    webnamefinal: ''
  }),
  computed: {
    getCurrentStep() {
      return this.$store.state.register.currentStep
    },
    isInIframe: function() {
      return window.location != window.parent.location ? true : false
    },
    logourl: function() {
      return process.env.BASE_URL + this.webnamefinal + '/logo.png'
    },
    premiumcode() {
      if (!this.$store.state.decoupled.configFile) return true
      return this.$store.state.decoupled.configFile.config.register.premiumcode
    },
    isDataLoaded() {
      if (this.webnamefinal === 'tokmedicine') {
        return this.$store.state.register.registerConfiguration !== null
      } else return this.$store.getters['decoupled/isInit']
    },
    isApp() {
      return this.$store.state.isApp
    }
  },
  methods: {
    goBack() {
      if (this.getCurrentStep === 0) {
        window.location.href = 'tokmed://register/cancel'
        return false
      } else {
        this.$store.commit('register/prevStep')
        return true
      }
    }
  },
  created() {
    this.$store.commit('setAppMode', this.isapp.toLowerCase() == 'true')
    let promise1 = this.retrieveConfigFilesAndInit()
    promise1.finally(() => {
      if (this.webnamefinal === 'tokmedicine') {
        this.$store.dispatch('register/getRegisterConfiguration')
      }
      if (this.premiumcode === false) {
        if (this.getCurrentStep === 0) {
          this.$store.commit('register/nextStep')
        }
      }
    })
    window.goBack = this.goBack

    /* if(this.webname.length<1)
      this.webnamefinal=this.getSlugFromHost()
    else this.webnamefinal=this.webname
    this.$store.dispatch('decoupled/getConfigFile',{'slug':this.webnamefinal,'force':false})
    .finally(()=>{
      console.log("config file loaded")
      this.addCSS(process.env.BASE_URL +  this.webnamefinal + '/site.css')
      this.loading= false
      if(this.premiumcode == false) {
        this.$store.commit('register/nextStep')
        console.log(this.premiumcode)
      }
    })
    */
  }
}
</script>

<style lang="less">
@import (reference) '../assets/styles/common.less';

#content-frame {
  margin: auto;
  margin-top: 42px;
  margin-bottom: 42px;
  width: 500px;
  min-height: calc(100vh - 42px * 3.5);
  position: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background-color: #fff;
}

.register-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#content-inner {
  max-width: 400px;
  padding: 16px;
  padding-bottom: 32px;
  margin: auto;
  margin-top: 0px;
  margin-bottom: 0px;
}

#content-frame,
#content-inner,
#content-main {
  display: flex;
  flex-direction: column;
  flex: 1;
}

#register-container {
}
.register-inner {
  margin: auto;
  width: 100vw;
  max-width: 450px;
  min-height: 100vh;
  position: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#register-card {
  background-color: #fff;
  padding: 32px;
  padding-top: 16px;
  padding-bottom: 64px;
  border: 1px solid #9cafb7;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  flex: 1;
  display: flex;
  max-height: 700px;
}

.register-step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

@media (max-width: @mobilebreakpoint) {
  .top-part-notmobile {
    display: none;
  }
  #register-card {
    border-radius: 0px;
    padding-top: 0px;
    border: none;
    box-shadow: none;
    max-height: none;
  }
  #content-frame {
    width: auto;
    box-shadow: none;
    border-radius: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  #register-container {
    background: #fff;
  }
  .register-header {
    margin-left: -20px;
  }
}
@media (max-width: 450px) {
  #register-container {
    /*  width: 100%;
    height: 100vh;*/
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
  }
}
</style>
